import { useEffect, useState } from "react";
import api from "../../lib/api";
import { Cake, IceCream, FileText, MessageSquare } from "lucide-react";

export default function AdminDashboard() {
    const [stats, setStats] = useState({ cakes: 0, flavours: 0, blogs: 0, inquiries: 0 });

    useEffect(() => {
        Promise.all([
            api.get("/cakes?active_only=false"),
            api.get("/flavours?active_only=false"),
            api.get("/blogs?published_only=false"),
            api.get("/inquiries"),
        ])
            .then(([c, f, b, i]) => {
                setStats({ cakes: c.data.length, flavours: f.data.length, blogs: b.data.length, inquiries: i.data.length });
            })
            .catch(() => {});
    }, []);

    const cards = [
        { label: "Cakes", value: stats.cakes, icon: Cake, color: "bg-blush" },
        { label: "Flavours", value: stats.flavours, icon: IceCream, color: "bg-ink" },
        { label: "Blogs", value: stats.blogs, icon: FileText, color: "bg-blush" },
        { label: "Inquiries", value: stats.inquiries, icon: MessageSquare, color: "bg-ink" },
    ];

    return (
        <div data-testid="admin-dashboard">
            <h2 className="font-display text-3xl mb-6">Overview</h2>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                {cards.map((c) => (
                    <div key={c.label} className="bg-white border border-[#EAE3DE] p-5" data-testid={`stat-${c.label.toLowerCase()}`}>
                        <div className={`${c.color} w-10 h-10 flex items-center justify-center text-white mb-3`}>
                            <c.icon size={18} />
                        </div>
                        <p className="text-3xl font-display text-ink">{c.value}</p>
                        <p className="text-xs tracking-[0.25em] uppercase text-ink-soft mt-1">{c.label}</p>
                    </div>
                ))}
            </div>
        </div>
    );
}
